import careerInfo1 from "../../../../Assets/Images/Careers/careerInfo1.svg";
import careerInfo2 from "../../../../Assets/Images/Careers/careerInfo2.svg";

import {
    Section,
    SectionHeading,
    TextRow,
    StepWrapper,
    StepContainer,
    StepInfo,
    StepButtonWrapper,
} from "./styles";

import buttonArrow from "../../../../Assets/Images/Home/footer-arrow.svg";
import { useNavigate } from "react-router-dom";

const infos = [
    {
        img: careerInfo1,
        title: "Let’s craft digital products",
        description: `We’re on a mission to craft exceptional digital products code, design, and strategy in perfect sync. If you thrive on real impact, creative freedom, and team-driven progress, you’ll feel at home here.<br /><br />We believe great work is done by people who love what they do. Join a team where innovation meets execution, and every project is an opportunity to make something meaningful.`,
    },
    {
        img: careerInfo2,
        title: "Our culture & values",
        description:
            "Collaborative & Humble: We believe great work happens when diverse perspectives align<br /><br />Quality-Driven: We bring care to every pixel, line of code, and QA cycle<br /><br />Growth-Minded: Whether you're junior or senior, you'll grow-through mentorship and hands-on challenges",
    },
];

const CareerInfo = () => {
    const navigate = useNavigate();

    return (
        <Section>
            <StepWrapper>
                {infos.map((step, index) => (
                    <StepContainer key={index}>
                        {index % 2 === 0 && (
                            <img src={step.img} alt={step.title} />
                        )}
                        <StepInfo>
                            <span>{step.title}</span>
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: step.description,
                                }}
                            />
                        </StepInfo>
                        {index % 2 === 1 && (
                            <img src={step.img} alt={step.title} />
                        )}
                    </StepContainer>
                ))}
            </StepWrapper>
        </Section>
    );
};

export default CareerInfo;
